import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {nameValidation, phoneValidation, emailValidation, passwordValidation} from '../../../utils/itemValidation';
import {saveLogin} from '../../../utils/auth';

import * as authConstants from '../../../constants/auth';

import * as authActionCreators from '../../../actions/auth';
import * as commonActionCreators from '../../../actions/common';
import * as userActionCreators from '../../../actions/user';
let allActionCreators = Object.assign({}, authActionCreators, commonActionCreators, userActionCreators);

class Register extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {

      requestPending: false,
      serverError: null,

      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      password1: '',
      password2: '',

      firstNameError: null,
      lastNameError: null,
      emailError: null,
      phoneError: null,
      password1Error: null,
      password2Error: null,

      validationMessage: '',
    };

    this.altMessage = 'A customer with the same email address already exists.';
	}

	componentDidMount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  closeLogin() {
    this.props.commonCloseLogin();
  }

  changeFirstName(evt) {
    this.setState({ firstName: evt.target.value });
  }

  changeLastName(evt) {
    this.setState({ lastName: evt.target.value });
  }

  changeEmail(evt) {
    this.setState({ email: evt.target.value });
  }

  changePhone(evt) {
    this.setState({ phone: evt.target.value });
  }

  changePassword1(evt) {
    this.setState({ password1: evt.target.value });
  }

  changePassword2(evt) {
    this.setState({ password2: evt.target.value });
  }

  validateFirstName() {
    this.setState({ firstNameError: nameValidation(this.state.firstName) });
  }

  validateLastName() {
    this.setState({ lastNameError: nameValidation(this.state.lastName) });
  }

  validateEmail() {
    this.setState({ emailError: emailValidation(this.state.email) });
  }

  validatePhone() {
    this.setState({ phoneError: phoneValidation(this.state.phone) });
  }

  validatePassword1() {
    this.setState({ password1Error: passwordValidation(this.state.password1) });
  }

  validatePassword2() {
    this.setState({ password2Error: this.state.password1 == this.state.password2 ? null : 'Passwords must match' });
  }

  privacyNav() {
    this.closeLogin();
    this.internalNav('privacy-policy')
  }

  validateAll() {
    let firstNameError = nameValidation(this.state.firstName);
    let lastNameError = nameValidation(this.state.lastName);
    let emailError = emailValidation(this.state.email);
    let phoneError = phoneValidation(this.state.phone);
    let password1Error = passwordValidation(this.state.password1);
    let password2Error = this.state.password1 == this.state.password2 ? null : 'Passwords must match';

    this.setState({
      firstNameError: firstNameError,
      lastNameError: lastNameError,
      emailError: emailError,
      phoneError: phoneError,
      password1Error: password1Error,
      password2Error: password2Error,
    });
    if(
      firstNameError === null &&
      lastNameError === null &&
      emailError === null &&
      phoneError === null &&
      password1Error === null &&
      password2Error === null
    ) {
      return true;
    } else {
      return false;
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();

    if(this.validateAll()) {

      this.setState({
        requestPending: true,
        serverError: null,
      });

      let firstNameDatum = this.state.firstName.replace(/[^\w\s]/gi, '');
      let lastNameDatum = this.state.lastName.replace(/[^\w\s]/gi, '');
      let emailDatum = this.state.email;
      let phoneDatum = this.state.phone;

      const registerData = {
        customer: {
          firstname: this.state.firstName,
          lastname: this.state.lastName,
          email: this.state.email,
        },
        password: this.state.password1,
      }

      this.props.authRegister(registerData)
      .then((resp) => {
        console.log(resp);

        this.props.authLogin(this.state.email, this.state.password1)
        .then((resp) => {
          this.setState({
            requestPending: false,
            serverError: null,

            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            password1: '',
            password2: '',

            firstNameError: null,
            lastNameError: null,
            emailError: null,
            phoneError: null,
            password1Error: null,
            password2Error: null,

            validationMessage: '',
          }, () => {
            saveLogin(resp);
            this.props.authSave(resp, Date.now() + authConstants.LOGOUT_TIME);

            setTimeout(() => {

              console.log(this.props);

              let baseData = {
                firstName: firstNameDatum,
                lastName: lastNameDatum,
                email: emailDatum,
                phone: phoneDatum,
              };
              this.props.userSetProfile(baseData)
              .then((resp) => {
                this.internalNav('account');
              });

            }, 25);
            this.closeLogin();
          });
        });
      })
      .catch((resp) => {

        const testMessage = 'A customer with the same email address already exists in an associated website.';

        this.setState({ 
          validationMessage: resp.message.includes(testMessage) ? this.altMessage : resp.message, 
          requestPending: false,
        });
      });
    } 
  }

	render() {
		return <div className='Register'>
			<div className='loginClose' onClick={::this.closeLogin}>
        <div className='closeX'>&times;</div>
      </div>
      <div className='loginInnerWrapper'>
        <div className='loginTitle'>Create an Account</div>
        <div className='loginHr'></div>
        <div className='loginText'>Your Diamonds Direct online account will allow you to manage your orders, addresses, and payment methods.</div>
        {this.state.validationMessage ?
          <div className='errorMessage'>
            {this.state.validationMessage}
            {this.state.validationMessage == this.altMessage ?
              <span 
                className='signInLink' 
                onClick={::this.props.toggleMethod}
                style={{
                  fontSize: '14px',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  color: '#4B2D53',
                  padding: '0 0 0 0',
                  margin: '0 0 0 10px',
                }}>Sign In</span> :
              null
            }
          </div> :
          null
        }
        <div className='loginFormWrapper'>
          <form className='loginForm' onSubmit={::this.handleSubmit}>
            <div className='loginFormRow'>
              <div className='loginInputLabel'>First Name</div>
              <input 
                type='text'
                className={this.state.firstNameError ? 'error' : ''}
                value={this.state.firstName}
                onChange={::this.changeFirstName}
                onBlur={::this.validateFirstName} />
              {this.state.firstNameError ?
                <div className='loginInputError'>{this.state.firstNameError}</div> :
                null
              }
            </div>
            <div className='loginFormRow'>
              <div className='loginInputLabel'>Last Name</div>
              <input 
                type='text'
                className={this.state.lastNameError ? 'error' : ''}
                value={this.state.lastName}
                onChange={::this.changeLastName}
                onBlur={::this.validateLastName} />
              {this.state.lastNameError ?
                <div className='loginInputError'>{this.state.lastNameError}</div> :
                null
              }
            </div>
            <div className='loginFormRow'>
              <div className='loginInputLabel'>Email</div>
              <input 
                type='email'
                className={this.state.emailError ? 'error' : ''}
                value={this.state.email}
                onChange={::this.changeEmail}
                onBlur={::this.validateEmail} />
              {this.state.emailError ?
                <div className='loginInputError'>{this.state.emailError}</div> :
                null
              }
            </div>
            <div className='loginFormRow'>
              <div className='loginInputLabel'>Phone Number</div>
              <input 
                type='phone'
                className={this.state.phoneError ? 'error' : ''}
                value={this.state.phone}
                onChange={::this.changePhone}
                onBlur={::this.validatePhone} />
              {this.state.phoneError ?
                <div className='loginInputError'>{this.state.phoneError}</div> :
                null
              }
            </div>
            <div className='loginFormRow'>
              <div className='loginInputLabel'>Password</div>
              <input 
                type='password'
                className={this.state.password1Error ? 'error' : ''}
                value={this.state.password1}
                onChange={::this.changePassword1}
                onBlur={::this.validatePassword1} />
              {this.state.password1Error ?
                <div className='loginInputError'>{this.state.password1Error}</div> :
                null
              }
            </div>
            <div className='loginFormRow'>
              <div className='loginInputLabel'>Re-enter Password</div>
              <input 
                type='password'
                className={this.state.password2Error ? 'error' : ''}
                value={this.state.password2}
                onChange={::this.changePassword2}
                onBlur={::this.validatePassword2} />
              {this.state.password2Error ?
                <div className='loginInputError'>{this.state.password2Error}</div> :
                null
              }
            </div>
            <div className='loginFormRow'>
              <div className='loginFormButtonWrapper'>
                <button 
                  className={'registerFormButton dd2ActionButton'}
                  disabled={this.state.requestPending}
                  type='submit'>
                  Create Account
                </button>
              </div>
            </div>
          </form>
        </div>
        <div className='toggleArea'>
          <div className='toggleText'>Already have a Diamonds Direct account?</div>
          <div className='toggleLink' onClick={::this.props.toggleMethod}>Sign into an existing account.</div>
          <div className={'toggleLink privacyLink'} onClick={::this.privacyNav}>Privacy Policy</div>
        </div>
      </div>
		</div>;
	}
}
export default Register;

function mapStateToProps(state) {
  return {

  };
}

export const RegisterContainer = connect(
  mapStateToProps,
  allActionCreators
)(Register);


// WEBPACK FOOTER //
// ./src/components/views/login/Register.jsx